// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItemModel, { TYPES } from "app/models/TimelineItem";

import NotSupportedTimelineItem from "app/components/TimelineItem/NotSupportedTimelineItem/NotSupportedTimelineItem";

import "./TimelineItem.scss";
import AppearanceStore from "../../stores/AppearanceStore";

export const size = 48;
const MIN_EMBED_SCALE = 0.35;
const MAX_EMBED_SCALE = 0.675;

type Props = {
    authorImage: ?string,
    item: TimelineItemModel,
    selected?: boolean,
    onSelect?: Function,
    onDeselect?: Function,
    onSeek?: Function,
    onMouseEnter?: Function,
    scale: number,
    wizard?: boolean,
    freezeScale?: boolean
};

@observer
export default class TimelineItem extends React.Component<Props> {
    button: ?HTMLElement;

    static types: { [string]: Function } = {};

    static pushType(type: string, component: Function) {
        this.types[type] = component;
    }

    handleClick() {
        if (this.props.selected) {
            if (!this.props.wizard && this.props.onDeselect) {
                this.props.onDeselect();
            }
        } else if (this.props.onSelect) {
            this.props.onSelect(this.props.item);
        }
    }

    handleMouseEnter() {
        if (this.props.onMouseEnter) {
            this.props.onMouseEnter(this.props.item);
        }
    }

    handleForward = () => {
        this.props.onSeek && this.props.onSeek(this.props.item.start_time);
    };

    componentDidMount() {
        if (!this.button) return;
        const button = this.button;

        button.addEventListener("mouseenter", this.handleMouseEnter.bind(this));
    }

    render() {
        const scale = this.props.scale;
        const item = this.props.item;
        const type = item.type ? item.type : "";

        let classes = ["TimelineItem"];
        if (this.props.selected) classes.push("TimelineItem--selected");

        const component = this.renderByType();
        if (!component) return null;

        const style = {};

        if (AppearanceStore.embed) {
            const embedScale = document.body.offsetWidth / 780;
            const embedSize =
                Math.min(
                    MAX_EMBED_SCALE,
                    Math.max(MIN_EMBED_SCALE, embedScale)
                ) * size;

            style.width = `${embedSize}px`;
            style.height = `${embedSize}px`;
            style.marginLeft =`-${embedSize/2}px`; 
        } else if (!this.props.freezeScale && scale !== -1) {
            style.width = `${size * scale}px`;
            style.height = `${size * scale}px`;
            style.marginLeft =`-${size * scale/2}px`; 
        } else if (AppearanceStore.isMobile) {
            style.width = "30px";
            style.height = "30px";
            style.marginLeft = "-15px"; 
        }

        const buttonClasses = ["TimelineItem__button"];
        if (this.props.wizard) {
            buttonClasses.push('TimelineItem__button__pointer');
        }


        return (
            <div className={classes.join(" ")}>
                <div className="TimelineItem__button__positioner">
                    <button
                        ref={button => (this.button = button)}
                        type="button"
                        className={buttonClasses.join(" ")}
                        onClick={this.handleClick.bind(this)}
                        style={style}
                    >
                        <div className={`TimelineItem__content ${type}`}>
                            {component}
                        </div>
                    </button>
                </div>

                {this.renderForward()}
            </div>
        );
    }

    renderByType() {
        const item = this.props.item;
        let type = item.type;

        if (!type && this.props.wizard && this.props.selected) {
            type = TYPES.WIZARD;
        }

        let typeClass = this.constructor.types[type];

        if (!typeClass) {
            console.warn(
                item.type + " item type not supported. Item #" + item.rowid
            );
            typeClass = NotSupportedTimelineItem;
        }

        // $FlowFixMe
        return React.createElement(typeClass, {
            authorImage: this.props.authorImage,
            item,
            scale: this.props.scale
        });
    }

    renderForward() {
        if (!this.props.onSeek || !this.props.selected) return null;

        return (
            <button
                className="TimelineItem__forward"
                onClick={this.handleForward}
            >
                <i className="fa fa-forward" />
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineItem/TimelineItem.js